const Login = () => import('@/views/Login')

export default [
  {
    path: '/login',
    component: Login
  }
]
